import axios from 'axios';
import { BASE_URL } from '../constants/api';
import helperService from './helper';
import axiosRetry from 'axios-retry';
import { saveAs  } from 'file-saver';
/**
 *
 * Common Services class for making API requests
 *
 */
class CommonService {
  instance = {};

  /**
   * Initiating Axios to make HTTP request,
   * adds default headers for request
   * like Bearer token using helper service
   */
  constructor() {
    this.instance = axios.create({
      baseURL: `${BASE_URL}`,
    });
    this.instance.interceptors.request.use((req) => {
      const headers = helperService.getHeaders();
      //headers.responseType= 'blob';
      const defaultHeaders = this.instance.defaults.headers.common;
      req.headers = { ...defaultHeaders, ...headers };
      return req;
    });

    /**
     * Adds ability to retry requests
     * Default: retries if it is a network error or a 5xx error on an idempotent request (GET, HEAD, OPTIONS, PUT or DELETE).
     */
    axiosRetry(this.instance, {
      retries: 3,
      retryDelay: (retryCount) => {
        return retryCount * 1000;
      },
    });
  }

  /**
   * Used for making HTTP GET requests
   *
   * @param relativePath - The endpoint of the API
   * @param params - The body params of the API
   * @return {Promise<*>} returns response from server as promise
   */
  async getFromServer(relativePath, params = {}) {
    try {
      const result = await this.instance.get(relativePath, { params });
      if (result.status === 204) {
        return "no content to show";
      }
      return result.data;
    } catch (e) {
      const error= new Error(e);
      error.message=e.message;
      error.code=e.response.status;
      error.msg=e.response.data;      
      throw error;
    }
  }

  /**
   * Used for making HTTP POST requests
   *
   * @param relativePath - The endpoint of the API
   * @param params - The body params of the API
   * @return {Promise<*>} returns response from server
   */
  async postToServer(relativePath, params = {}) {
    try {
      const result = await this.instance.post(relativePath, params);
      return result.data;
    } catch (e) {
      const error= new Error(e);
      error.code=e.response.status;
      error.msg=e.response.data;      
      throw error;
    }
  }
  async downloadFromSSRS(relativePath, params, fileName) {
    try {
      let instance = "";
      let url = "";
    
        instance = axios.create({
          baseURL: `${BASE_URL}` + relativePath,
        });
        url = `${BASE_URL}` + relativePath;
    

      const method = "POST";
      let AxiosRequestConfig = {
        url,
        method,
        headers: helperService.getHeaders(),
        data: params,
        responseType: "blob",
      };
      return instance.request(AxiosRequestConfig).then((response) => {
        let url = window.URL.createObjectURL(new Blob([response.data]));
        saveAs(url, fileName);
      });
    } catch (e) {
      const error = new Error(e);
      error.code = e.response.status;
      error.msg = e.response.data;
      throw error;
    }
  }
  async downloadFromServer(relativePath, params) {
    try {
      let instance = "";
      let url = "";
      if (params.id) {
        instance = axios.create({
          baseURL: `${BASE_URL}` + relativePath + "/" + params.id,
        });
        url = `${BASE_URL}` + relativePath + "/" + params.id;
      } else {
        instance = axios.create({
          baseURL: `${BASE_URL}` + relativePath,
        });
        url = `${BASE_URL}` + relativePath;
      }

      const method = "GET";
      let AxiosRequestConfig = {
        url,
        method,
        headers: helperService.getHeaders(),
        data: params,
        responseType: "blob",
      };
      return instance.request(AxiosRequestConfig).then((response) => {
        let url = window.URL.createObjectURL(new Blob([response.data]));
        saveAs(url, params.fileName);
      });
    } catch (e) {
      const error = new Error(e);
      error.code = e.response.status;
      error.msg = e.response.data;
      throw error;
    }
  }

  /**
   * Used for making HTTP PUT requests
   *
   * @param relativePath - The endpoint of the API
   * @param params - The body params of the API
   * @return {Promise<*>} returns response from server
   */
  async updateToServer(relativePath, params = {}) {
    try {
      const result = await this.instance.put(relativePath, params);
      return result.data;
    } catch (e) {
      throw new Error(e.message);
    }
  }

  /**
   * Used for making HTTP DELETE requests
   *
   * @param relativePath - The endpoint of the API
   * @param params - The body params of the API
   * @return {Promise<*>} returns response from server
   */
  async deleteToServer(relativePath, params = {}) {
    try {
      const result = await this.instance.delete(relativePath);
      return result.data;
    } catch (e) {
      throw new Error(e.message);
    }
  }
}

export default new CommonService();
